function new_map($el,zoom) {
  var $markers = $el.find('.marker');
  var args = {
    zoom: zoom,
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    /*
     * snazzy maps settings
    styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers":[{"visibility":"off"},{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"color":"#ff0000"},{"visibility":"off"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.fill","stylers":[{"visibility":"off"},{"color":"#385c47"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.stroke","stylers":[{"visibility":"off"},{"color":"#ff0000"},{"weight":"7.81"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"weight":"1.00"},{"gamma":"1.33"},{"lightness":"0"},{"saturation":"6"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#d49a9a"}]},{"featureType":"road.arterial","elementType":"labels.text","stylers":[{"visibility":"on"},{"color":"#000000"},{"weight":"0.25"}]},{"featureType":"road.arterial","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ddaaaa"},{"lightness":"22"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#000000"},{"weight":"0.01"}]},{"featureType":"road.local","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#a4ced7"},{"visibility":"on"}]}]
    */
  };
  var map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function() {
    add_marker($(this), map);
  });
  center_map(map,zoom);
  return map;
}

function add_marker($marker, map) {
  var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
  var marker = new google.maps.Marker({
    position: latlng,
    map: map
  });
  map.markers.push(marker);
  if ($marker.html()) {
    var infowindow = new google.maps.InfoWindow({
      content: $marker.html()
    });
    google.maps.event.addListener(marker, 'click', function() {
      infowindow.open(map, marker);
    });
  }
}


function center_map(map,zoom) {
  var bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function(i, marker) {
    var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(zoom);
  } else {
    map.fitBounds(bounds);
  }
}


$(document).ready(function() {
  $('.gmap-embed').each(function() {
    var map = new_map($(this),$(this).data('zoom'));
  });
});
